import React from 'react';

import FormElementContainer from '../FormElement/FormElementContainer';
import { formElemHasError } from '../helpers/getClassName';
import cn from 'utils/cn';

/**
 * @deprecated This component is deprecated.
 * Use the `src/components/3.0/Forms/Input/InputWithLabel.tsx` instead.
 */
function Input({
  containerProps = {},
  label,
  errors = {},
  inputName,
  inputProps,
  labelProps = {},
  showErrorMessageBelow,
  required = false,
  instructionsLabel = '',
  hideWarningLabelOnFormElement = false,
}) {
  const hasError = formElemHasError(inputName, errors);

  return (
    <FormElementContainer
      {...{
        containerProps,
        label,
        errors,
        inputName,
        showErrorMessageBelow,
        labelProps,
        required,
        instructionsLabel,
        hideWarningLabelOnFormElement,
      }}
    >
      <input
        {...inputProps}
        className={cn('form-elem form-input', inputProps?.className)}
        aria-invalid={hasError ? 'true' : 'false'}
      />
    </FormElementContainer>
  );
}

export default Input;
